import React from "react";
import { useAppContext } from "../../hooks/useAppContext";
import { getTranslation } from "../../locales/getTranslation";
import Tooltip from "../Tooltip";

export interface RedoButtonProps {
  className?: string;
  question: string;
  onSend: (question: string) => void;
  disabled: boolean;
}

const Redo = ({ className, question, onSend, disabled }: RedoButtonProps) => {
  const { locale } = useAppContext();

  const sendQuestion = () => {
    if (disabled || !question.trim()) {
      return;
    }

    onSend(question);
  };

  return (
    <>
      <Tooltip text={getTranslation(locale, "Redo Tooltip")} position="bottom">
        <svg
          className={className}
          onClick={sendQuestion}
          width="12"
          height="12"
          viewBox="0 0 12 12"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M10.4289 5.66667C10.9284 5.66667 11.3334 5.2488 11.3334 4.73333V1.62222C11.3334 1.27858 11.0634 1 10.7304 1C10.3974 1 10.1274 1.27858 10.1274 1.62222V3.56602C9.30454 2.03573 7.72282 1 5.90668 1C3.81456 1 2.03352 2.37443 1.36521 4.29602C1.23326 4.67543 1.52929 5.04444 1.91992 5.04444C2.20418 5.04444 2.4472 4.84322 2.55434 4.57151C3.09253 3.20664 4.39072 2.24444 5.90668 2.24444C7.36676 2.24444 8.62482 3.137 9.19643 4.42222H7.41408C7.08108 4.42222 6.81112 4.7008 6.81112 5.04444C6.81112 5.38809 7.08108 5.66667 7.41408 5.66667H10.4289Z" />
          <path d="M1.57113 6.33333C1.07162 6.33333 0.666687 6.7512 0.666687 7.26667V10.3778C0.666687 10.7214 0.936643 11 1.26965 11C1.60266 11 1.87262 10.7214 1.87262 10.3778V8.43398C2.6955 9.96427 4.27722 11 6.09336 11C8.18548 11 9.96652 9.62557 10.6348 7.70398C10.7668 7.32457 10.4707 6.95556 10.0801 6.95556C9.79586 6.95556 9.55284 7.15678 9.4457 7.42849C8.90751 8.79336 7.60932 9.75556 6.09336 9.75556C4.63328 9.75556 3.37522 8.863 2.80361 7.57778H4.58596C4.91896 7.57778 5.18892 7.2992 5.18892 6.95556C5.18892 6.61191 4.91896 6.33333 4.58596 6.33333H1.57113Z" />
        </svg>
      </Tooltip>
    </>
  );
};

export default Redo;
